import { OmniboxConfigurationService } from '../OmniboxConfigurationService';
import { SearchService } from '../services/SearchService';
import { ContentSuggestionViewModel } from './ContentSuggestionViewModel';

export class EmptyStateContentSuggestionViewModel extends ContentSuggestionViewModel {
    public initialize(): void {
        this.clearDataOnMount = false;

        this.maxContentSuggestionCount = OmniboxConfigurationService.instance.configuration.emptyStateContentSuggestionMaxCount;

        SearchService.instance.getEmptyContentSuggestions().then(result => {
            this.parseSuggestionData(result);
        });
    }
}
